import { render, staticRenderFns } from "./ContactUsLink.vue?vue&type=template&id=5aa57c94&"
import script from "./ContactUsLink.vue?vue&type=script&lang=ts&"
export * from "./ContactUsLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports